import React from 'react';

export function Notice() {
  return (
    <div className="tw-bg-yellow tw-p-4 md:tw-p-8 tw-overflow-hidden">
      <div className="scrolling-content">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="scrolling-section tw-flex tw-gap-8 tw-items-center">
            <p className="!tw-font-normal tw-whitespace-nowrap">
              With POD SecurePay, You can buy with confidence anywhere online.
            </p>
            <div className="tw-inline-flex tw-justify-between tw-items-center tw-gap-8">
              {[
                {
                  url: 'https://www.facebook.com/payondelivery',
                  icon: 'facebook.png',
                  alt: 'POD Facebook',
                },
                {
                  url: 'https://www.instagram.com/payondelivery',
                  icon: 'instagram.png',
                  alt: 'POD Instagram'
                },
                {
                  url: '',
                  icon: 'tiktok.png',
                  alt: 'POD TikTok'
                },
                {
                  url: '',
                  icon: 'whatsapp.png',
                  alt: 'POD WhatsApp',
                },
              ].map((social) => (
                <a key={social.icon} href={social.url} target="_blank">
                  <img
                    src={`/assets/images/social-icons-colored/${social.icon}`}
                    className='tw-w-[20px] md:tw-w-[32px] tw-h-[20px] md:tw-h-[32px]'
                    alt={social.alt}
                  />
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
